import { c as _c } from "react/compiler-runtime";
import PaginatedReviews from './PaginatedReviews';
import ReviewsListOptions from './ReviewsListOptions';
import { ReviewsProvider } from './context/reviews.provider';
import useReviews from './context/useReviews';
const ReviewsContent = (t0) => {
    const $ = _c(3);
    const { className: t1 } = t0;
    const className = t1 === undefined ? "" : t1;
    const { hasResults } = useReviews();
    let t2;
    if ($[0] !== className || $[1] !== hasResults) {
        t2 = hasResults ?
            <div className={className}>
      <ReviewsListOptions />

      <PaginatedReviews />
    </div> : <></>;
        $[0] = className;
        $[1] = hasResults;
        $[2] = t2;
    }
    else {
        t2 = $[2];
    }
    return t2;
};
const Reviews = (t0) => {
    const $ = _c(5);
    const { entity, className } = t0;
    let t1;
    if ($[0] !== className) {
        t1 = <ReviewsContent className={className}/>;
        $[0] = className;
        $[1] = t1;
    }
    else {
        t1 = $[1];
    }
    let t2;
    if ($[2] !== entity || $[3] !== t1) {
        t2 = <ReviewsProvider entity={entity}>{t1}
    </ReviewsProvider>;
        $[2] = entity;
        $[3] = t1;
        $[4] = t2;
    }
    else {
        t2 = $[4];
    }
    return t2;
};
export default Reviews;
